import {z} from 'zod';

/**
 * Three roles, ordered from most to least privileged.
 *
 * PLATFORM_ADMIN belongs to no organization and manages organizations themselves.
 * ORG_ADMIN and ORG_MEMBER always belong to exactly one organization.
 */
export const ROLES = ['PLATFORM_ADMIN', 'ORG_ADMIN', 'ORG_MEMBER'] as const;

export type Role = (typeof ROLES)[number];

export const roleSchema = z.enum(ROLES);

/** Roles that can be handed out through the API. PLATFORM_ADMIN is seeded, never granted. */
export const ASSIGNABLE_ROLES = ['ORG_ADMIN', 'ORG_MEMBER'] as const satisfies readonly Role[];

export type AssignableRole = (typeof ASSIGNABLE_ROLES)[number];

export const assignableRoleSchema = z.enum(ASSIGNABLE_ROLES);

const RANK: Record<Role, number> = {
  PLATFORM_ADMIN: 3,
  ORG_ADMIN: 2,
  ORG_MEMBER: 1,
};

export const hasAtLeast = (role: Role, minimum: Role): boolean => RANK[role] >= RANK[minimum];

export const isPlatformAdmin = (role: Role): boolean => role === 'PLATFORM_ADMIN';

export const isOrganizationScoped = (role: Role): boolean => !isPlatformAdmin(role);
